var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-content"},[_c('h1',{staticClass:"text-primary mb-25"},[_vm._v("\n\t\t"+_vm._s(_vm.$tc('components.noContentTitle'))+"\n\t")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$tc('common.contactSupportText')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }